export default __webpack_public_path__ + "static/media/mystic-monsoon-banner.3be068da.png";